import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef, MatPaginator, MatTableDataSource } from "@angular/material";
import { UserService } from "../../../service/user.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { usersLastestCampaignsReportFilter } from "../../../core/models/usersLastestCampaignsReportFilter.model";
import { AlertComponent } from "../alert/alert.component";
import { UserLastestCampaignsDto } from "../../../../app/persistence/dto/user-lastestcampaignsreport-model";
import { UIPermissionWrapper } from "../../../../app/model/ui-permission-wrapper.model";
import { FrontendService } from "../../../service/frontend.service";


@Component({
    selector: 'kt-dialog-user-latestcampaigns-report',
    templateUrl: './dialog-user-latestcampaigns-report.component.html',
    styleUrls: ['./dialog-user-latestcampaigns-report.component.scss'],
})
export class DialogUserLatestCampaignsReportComponent implements OnInit {

    isLoadingResults: boolean = false;
    @ViewChild('searchInputDivision') searchInputDivision: ElementRef;
    @ViewChild('searchInputZone') searchInputZone: ElementRef;
    @ViewChild('searchInputArea') searchInputArea: ElementRef;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    filtersSelected : number = 0;
    tableData: UserLastestCampaignsDto[] = [];
    dataSource: MatTableDataSource<UserLastestCampaignsDto>;

    displayedColumns = [
      'division',
      'zone',
      'area',
      'username',
      'name',
      'phone',
      'status',
      'o5',
      'o4',
      'o3',
      'o2',
      'o1',
      'actualCampaign'
    ];
    public permission: UIPermissionWrapper;



    constructor(
        public dialogRef: MatDialogRef<DialogUserLatestCampaignsReportComponent>,
        private cdr: ChangeDetectorRef,
        private userService: UserService,
        private dialog: MatDialog,
        private frontendService: FrontendService,

      ) { }


    ngOnInit(): void {
      this.permission = this.frontendService
      .permissionFor("views/pages/user-management/users/users-list/users-list.component");
    }


    onNoClick(): void {
        this.dialogRef.close(false);
    }

    filterConfiguration(): any {
      const filter: any = {};
     if (this.searchInputZone && this.searchInputZone.nativeElement.value) {
          filter.zona = this.searchInputZone.nativeElement.value;
          this.filtersSelected += 1;
      } else { filter.zona = 0 }

      if (this.searchInputDivision && this.searchInputDivision.nativeElement.value) {
          filter.division = this.searchInputDivision.nativeElement.value;
          this.filtersSelected += 1;
      } else { filter.division = 0 }

      if (this.searchInputZone && this.searchInputArea.nativeElement.value) {
          filter.area = this.searchInputArea.nativeElement.value;
          this.filtersSelected += 1;
      } else { filter.area = 0 }

      return filter
    }



  searchData() {

    this.isLoadingResults = true; 
    let filters = this.getFilters();

    if ( this.filtersSelected < 1){
      this.isLoadingResults = false; 

      this.dialog.open(AlertComponent, {
          width: '400px',
          data: {
              mensaje: 'Debe seleccionar un filtro adicional',
              title: 'Error'
          }
      });
    }
    else
    {

      this.userService.findUsersLastestCampaignsReport(filters).subscribe(x => 
        { 
          this.isLoadingResults = false; 
          this.tableData = x; 
          this.dataSource = new MatTableDataSource(this.tableData);
          this.paginator._intl.itemsPerPageLabel = 'Items por página';
          this.dataSource.paginator = this.paginator;
          this.paginator.length = this.tableData.length;
          this.paginator.pageSize = 20;
          this.cdr.detectChanges();
        },
          error => { alert('Error al buscar la información'), 
          this.isLoadingResults = false; 
          this.cdr.detectChanges(); 
        });
    }
  }

  getUserStatus(user: UserLastestCampaignsDto) {
    switch (parseInt(user.userStatus)) {
        case 2: // 'Inactive'
            return 'Inactiva 1';
        case 3: // 'InactiveTwo'
            return 'Inactiva 2';
        case 4: // 'InactiveFull'
            return 'Baja';
        case 5: // 'Blocked'
            return 'Bloqueada';
        case 1: // 'Active'
            return 'Activa';
        case 0: // 'New'
            return 'Nueva';
        default:
            return 'N/A';
    }
}

  exportReport() {
    let filters = this.getFilters();
    this.cdr.detectChanges();
    this.isLoadingResults = true; 

    if ( this.filtersSelected < 1){

      this.isLoadingResults = false; 
      this.dialog.open(AlertComponent, {
          width: '400px',
          data: {
              mensaje: 'Debe seleccionar un filtro adicional',
              title: 'Error'
          }
      });
    }
    else
    {
      this.exportExcel(this.userService.downloadUsersLastestCampaignsReport(filters), "ReporteGestion.xlsx");
    }
  }

  getFilters(){
    let filterConfig = this.filterConfiguration();
    let filters = new usersLastestCampaignsReportFilter();
    filters.area = filterConfig.area;
    filters.division = filterConfig.division;
    filters.zone = filterConfig.zona;
    return filters;
  }

  exportExcel(request, filename){
    request.subscribe(x => { saveAs(x, filename), this.isLoadingResults = false; this.cdr.detectChanges(); },
      error => { alert('Error al descargar el archivo'), this.isLoadingResults = false;  this.cdr.detectChanges(); });
  }

}